import styled from 'styled-components';
import { zLayoutNavigation } from 'core/styles/z-index';

export const FixedBannerDiv = styled.div<{ $visible: boolean }>`
  position: sticky;
  top: 0;
  z-index: ${zLayoutNavigation};
  max-height: ${({ $visible }) => ($visible ? '155px' : '0')};
  overflow: hidden;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  transform: translateY(${({ $visible }) => ($visible ? '0' : '-100%')});
  transition: all 0.3s ease;

  > div {
    position: relative;
  }
`;
